document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-b2b-price-login]');
  if (!link) return;

  const loginUrl = new URL(link.href, window.location.origin);
  const returnUrl = window.location.pathname + window.location.search;
  if (loginUrl.pathname.endsWith('/customer_authentication/login')) {
    loginUrl.searchParams.set('return_to', returnUrl);
  } else if (loginUrl.pathname.endsWith('/account/login')) {
    loginUrl.searchParams.set('return_url', returnUrl);
  } else {
    return;
  }
  link.href = loginUrl.href;
});
